var _defs, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRobot05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 271 265",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d1d3d4;}.cls-2{fill:#f2f2f2;}.cls-3{opacity:0.6;}.cls-4{fill:#2d5eab;}.cls-5{fill:#3c296b;}.cls-6,.cls-7{fill:#fff;}.cls-7{opacity:0.5;}.cls-8{fill:#a7a9ac;}.cls-9{fill:#939598;}.cls-10{fill:#6d6e71;}.cls-11{fill:#5a5a5c;}.cls-12{fill:#818082;}.cls-13{fill:#808285;}.cls-14{fill:#bcbec0;}.cls-15{fill:#ccc;}.cls-16{fill:#e6e7e8;}.cls-17{fill:#f1f2f2;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "robot") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.57,142.33V106.46c-6.77-1.83-19-1.36-19-1.36a83.3,83.3,0,0,0-13.11,1l-.16,0c-1.3.22-2.61.49-3.86.82l-.16,0-1,.28h0l-.79.25v34.78s.7,6,7.9,10.28,11.26,3.6,11.26,3.6a18.61,18.61,0,0,0,4.15-.68h0s3.25-.36,8.4-3.75c.42-.28.8-.56,1.16-.84C158.19,146.6,157.57,142.33,157.57,142.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132,88.25l-.75-9.44s-6.14-1.05-15.08,3.57c-7.6,3.93-12.58,11.45-12.58,11.45l4.56,4.7s3.16-5,11.28-8.12S132,88.25,132,88.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M141.78,87.41,142,78s6.06-1.43,15.27,2.64c7.83,3.45,13.26,10.65,13.26,10.65l-4.26,5s-3.47-4.83-11.76-7.41S141.78,87.41,141.78,87.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M140.64,103.39a2.45,2.45,0,0,0-2-1.08,115.13,115.13,0,0,1-2.43-30.45,3.9,3.9,0,1,0-.85,0,116.2,116.2,0,0,0,2.44,30.6,2.45,2.45,0,0,0-1.26.95,2.65,2.65,0,0,0-.64,1.71c0,1.48,1.2.82,2.67.82s2.67.65,2.67-.82A2.65,2.65,0,0,0,140.64,103.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M137.76,70.83l-.13-.35-.31-.81a0,0,0,0,1,0,0,1.89,1.89,0,0,0,.59-.76,2,2,0,0,0,.16-.65,2.11,2.11,0,0,0-.08-.77,2,2,0,0,0-.61-.95,2,2,0,0,0-1-.48,2,2,0,0,0-1.62.44,2,2,0,0,0-.69,1.12,2.07,2.07,0,0,0,.1,1.26,1.88,1.88,0,0,0,.58.77l0,0a0,0,0,0,1,0,0l-.44,1.16h0a3.23,3.23,0,0,1-1.49-3.43,3.28,3.28,0,0,1,6.38-.17A3.24,3.24,0,0,1,137.76,70.83Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 123.08,
    cy: 101.84,
    rx: 10.69,
    ry: 11.72
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 123.08,
    cy: 102.8,
    r: 9.94
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 122.62,
    cy: 102.66,
    rx: 4.86,
    ry: 5.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 123.67,
    cy: 103.11,
    rx: 2.27,
    ry: 2.75
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 124.82,
    cy: 102.84,
    rx: 0.74,
    ry: 0.89
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 120.21,
    cy: 105.13,
    rx: 1.1,
    ry: 1.33
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 126.15,
    cy: 102.15,
    rx: 0.42,
    ry: 0.51
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 153.93,
    cy: 101.84,
    rx: 10.69,
    ry: 11.72
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 153.93,
    cy: 103.76,
    rx: 9.94,
    ry: 8.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.41,215a59.76,59.76,0,0,0-13.17,1.36,25.24,25.24,0,0,1-11.4,0A59.76,59.76,0,0,0,119.68,215c-12.3,0-22.28,3.14-22.28,7s10,7,22.28,7a59.76,59.76,0,0,0,13.17-1.36,25.24,25.24,0,0,1,11.4,0A59.76,59.76,0,0,0,157.41,229c12.3,0,22.28-3.14,22.28-7S169.72,215,157.41,215Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M118.54,182.2H107.73a4.2,4.2,0,0,0-4,2.67,43.49,43.49,0,0,0-1.72,5.28,42.63,42.63,0,0,0,2.41,24.92,39.11,39.11,0,0,0,2.58,5.29c2,2.5,3.78,3.4,6.77,3.4h5.1a8.82,8.82,0,0,0,8.67-7.21h0c1.64-8.86-.16-17.79-2.77-26.33,0,0-1.53-3.61-2.22-4.72C121.5,183.85,120.29,182.2,118.54,182.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M127.53,216.57h0c1.64-8.86-.16-17.79-2.77-26.33,0,0-1.53-3.61-2.22-4.72-1-1.65-2.23-3.28-4-3.31-1.41,0-2.43.78-3.23,2.67a50.74,50.74,0,0,0-1.4,5.28,51.54,51.54,0,0,0,2,24.92,43.42,43.42,0,0,0,2.11,5.29,7.12,7.12,0,0,0,3.31,3A8.81,8.81,0,0,0,127.53,216.57Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 120.32,
    cy: 202.35,
    rx: 5.59,
    ry: 14.17,
    transform: "translate(-20.47 13.67) rotate(-5.99)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 120.96,
    cy: 202.35,
    rx: 5.05,
    ry: 12.79,
    transform: "translate(-20.46 13.73) rotate(-5.99)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 119.41,
    cy: 202.51,
    rx: 3.03,
    ry: 11.08,
    transform: "translate(-20.49 13.57) rotate(-5.99)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 118.77,
    cy: 202.51,
    rx: 2.29,
    ry: 8.37,
    transform: "translate(-20.49 13.51) rotate(-5.99)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M159.55,182.16h10.81a4.2,4.2,0,0,1,4,2.67,43.49,43.49,0,0,1,1.72,5.28A42.63,42.63,0,0,1,173.67,215a39.11,39.11,0,0,1-2.58,5.29c-2,2.5-3.78,3.4-6.77,3.4h-5.1a8.82,8.82,0,0,1-8.67-7.21h0c-1.64-8.86.16-17.79,2.77-26.33,0,0,1.53-3.61,2.22-4.72C156.59,183.8,157.8,182.16,159.55,182.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M150.55,216.52h0c-1.64-8.86.16-17.79,2.77-26.33,0,0,1.53-3.61,2.22-4.72,1-1.65,2.23-3.28,4-3.31,1.41,0,2.43.78,3.23,2.67a50.74,50.74,0,0,1,1.4,5.28,51.54,51.54,0,0,1-2,24.92,43.42,43.42,0,0,1-2.11,5.29,7.12,7.12,0,0,1-3.31,3A8.81,8.81,0,0,1,150.55,216.52Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 157.77,
    cy: 202.3,
    rx: 14.17,
    ry: 5.59,
    transform: "translate(-59.9 338.09) rotate(-84.01)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 157.13,
    cy: 202.3,
    rx: 12.79,
    ry: 5.05,
    transform: "translate(-60.47 337.46) rotate(-84.01)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 158.68,
    cy: 202.47,
    rx: 11.08,
    ry: 3.03,
    transform: "translate(-59.25 339.14) rotate(-84.01)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 159.31,
    cy: 202.47,
    rx: 8.37,
    ry: 2.29,
    transform: "translate(-58.68 339.77) rotate(-84.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M157.63,200.68c-1.84-1.72-8.21-6.79-19.2-6.79s-17,5-18.74,6.8A1.75,1.75,0,1,0,122,202.9c1.43-1.42,6.65-5.81,16.43-5.81s15.41,4.47,17,5.87a1.75,1.75,0,1,0,2.24-2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M141.48,150.37a16.31,16.31,0,0,0,9.16-6.58c3.08-4.12,1-12.13,1-12.13s-5,2.41-6.73,3.13a55.1,55.1,0,0,1-6.36,2.15,55.1,55.1,0,0,1-6.68.74c-1.86.07-7.42,0-7.42,0s1.49,8.14,6,10.57C134.58,150.47,137.84,151,141.48,150.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M124.43,137.7a26.6,26.6,0,0,0,2.17,5.53,14.08,14.08,0,0,0,1.59,2.44,7.89,7.89,0,0,0,2.09,1.89,19.45,19.45,0,0,0,5.38,2.09,14.78,14.78,0,0,0,5.71.08h-.07a15,15,0,0,0,5.16-2.49,19.2,19.2,0,0,0,4-4.16,7.17,7.17,0,0,0,.67-1.23,11.7,11.7,0,0,0,.44-1.37,13.88,13.88,0,0,0,.41-2.89,26.58,26.58,0,0,0-.37-5.95,20.56,20.56,0,0,1,.69,2.93,22.08,22.08,0,0,1,.31,3,14.28,14.28,0,0,1-.22,3.06,8.36,8.36,0,0,1-1.08,3,17,17,0,0,1-1.87,2.46,17.91,17.91,0,0,1-2.25,2.13,16,16,0,0,1-5.55,2.76h-.07a15.69,15.69,0,0,1-6.19-.17,18.09,18.09,0,0,1-2.93-1c-.47-.21-.93-.42-1.38-.66a11.76,11.76,0,0,1-1.34-.79,8.41,8.41,0,0,1-2.21-2.22A14.31,14.31,0,0,1,126,143.5a22.16,22.16,0,0,1-1-2.86A20.59,20.59,0,0,1,124.43,137.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M152.3,160.7l.44,2.94c.08,0,7.71-1.11,13.18,1.65s10,8.88,10,8.94l2.42-1.73c-.2-.27-4.87-6.73-11.1-9.87S152.65,160.65,152.3,160.7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 168,
    y: 181.35,
    width: 9.15,
    height: 4.08,
    rx: 2.04,
    ry: 2.04,
    transform: "translate(-56.07 288.91) rotate(-71.52)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 182.73,
    y: 180.9,
    width: 3.36,
    height: 12.23,
    rx: 1.68,
    ry: 1.68,
    transform: "translate(-77.63 169.21) rotate(-41.52)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 186.31,
    y: 178.02,
    width: 3.36,
    height: 13.96,
    rx: 1.68,
    ry: 1.68,
    transform: "translate(-75.39 171.08) rotate(-41.52)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 188.74,
    y: 175.58,
    width: 3.36,
    height: 12.23,
    rx: 1.68,
    ry: 1.68,
    transform: "translate(-72.59 171.86) rotate(-41.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M178.61,183l-4.74-5.35c-1-1.11.17-3.74,2.57-5.86s5.15-3,6.13-1.84l4.74,5.35Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 150.38,
    cy: 161.88,
    rx: 5.4,
    ry: 5.1,
    transform: "translate(-67.12 123.01) rotate(-36.98)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 150.2,
    cy: 161.64,
    r: 4.8,
    transform: "translate(-67.01 122.85) rotate(-36.98)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 151.13,
    cy: 160.93,
    r: 3.64,
    transform: "matrix(0.8, -0.6, 0.6, 0.8, -66.41, 123.27)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M123.11,163l-.44-2.94c-.08,0-7.71,1.11-13.18-1.65s-10-8.88-10-8.94l-2.42,1.73c.2.27,4.87,6.73,11.1,9.87S122.76,163,123.11,163Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 98.27,
    y: 138.26,
    width: 9.15,
    height: 4.08,
    rx: 2.04,
    ry: 2.04,
    transform: "translate(268.5 87.24) rotate(108.48)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 89.32,
    y: 130.55,
    width: 3.36,
    height: 12.23,
    rx: 1.68,
    ry: 1.68,
    transform: "translate(249.72 178.68) rotate(138.48)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 85.75,
    y: 131.7,
    width: 3.36,
    height: 13.96,
    rx: 1.68,
    ry: 1.68,
    transform: "translate(244.81 184.57) rotate(138.48)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 83.31,
    y: 135.87,
    width: 3.36,
    height: 12.23,
    rx: 1.68,
    ry: 1.68,
    transform: "translate(242.74 191.97) rotate(138.48)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.8,140.69l4.74,5.35c1,1.11-.17,3.74-2.57,5.86s-5.15,3-6.13,1.84l-4.74-5.35Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 125.03,
    cy: 161.8,
    rx: 5.4,
    ry: 5.1,
    transform: "translate(-72.18 107.75) rotate(-36.98)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 125.21,
    cy: 162.04,
    r: 4.8,
    transform: "translate(-72.28 107.91) rotate(-36.98)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 124.28,
    cy: 162.74,
    r: 3.64,
    transform: "translate(-72.89 107.49) rotate(-36.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M138.69,172.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M141.65,183.17a.08.08,0,0,0,0,.11l.7,1.85-.7-1.85A.08.08,0,0,1,141.65,183.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M140.68,175.3a4.71,4.71,0,0,1,2,1.71,4.71,4.71,0,0,0-2-1.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M149.91,188.81V160.35c-4-1.45-11.26-1.08-11.26-1.08s-6.64-.12-11.36,1.94v27.6A12.84,12.84,0,0,0,132,197c4.28,3.43,6.69,2.86,6.69,2.86s3.47,0,7.56-3.64S149.91,188.81,149.91,188.81Zm-6.84-2.15-.89.54-.37-1-.1-.26-.2-.54-.18-.46-.53-1.38a1,1,0,0,1,.31-1.11,3.44,3.44,0,0,0,1.08-1.39,3.76,3.76,0,0,0,.29-1.21,3.92,3.92,0,0,0-.15-1.44,3.74,3.74,0,0,0-3.06-2.65,4.67,4.67,0,0,0-.63,0,3.68,3.68,0,0,0-2.41.86,3.58,3.58,0,0,0-1.27,2.08,3.84,3.84,0,0,0,.19,2.36,3.41,3.41,0,0,0,1,1.4,1,1,0,0,1,.23.22,1,1,0,0,1,.14.9l-1,2.6,0,0a.93.93,0,0,1-.08.16l-.43.74-.75-.44a8.35,8.35,0,0,1,4-15.46h.39a8.35,8.35,0,0,1,8.09,6.27A8.25,8.25,0,0,1,143.07,186.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M145.55,176.55l0,0a7.49,7.49,0,0,0-.55-1l0-.07a7.54,7.54,0,0,0-.69-.88l-.08-.09a7.55,7.55,0,0,0-.8-.74l-.11-.09a7.52,7.52,0,0,0-.9-.59l-.13-.07a7.46,7.46,0,0,0-1-.44l-.15-.05a7.43,7.43,0,0,0-1.05-.27l-.16,0a7.49,7.49,0,0,0-1.11-.09h-.43a7.5,7.5,0,0,0-7,6,7.63,7.63,0,0,0-.1,2.46,7.38,7.38,0,0,0,2.63,4.78,7,7,0,0,0,.87.61v0l1-2.64a.09.09,0,0,0,0-.07l-.07-.06a4.3,4.3,0,0,1-1.32-1.76,4.67,4.67,0,0,1-.34-2.14,5.11,5.11,0,0,1,.11-.73,4.62,4.62,0,0,1,.56-1.42,4.49,4.49,0,0,1,1-1.14,4.89,4.89,0,0,1,.77-.51l.26-.12a4.45,4.45,0,0,1,.57-.22l.31-.08a4.59,4.59,0,0,1,.59-.09l.31,0h.14a5.52,5.52,0,0,1,.75.05,4.51,4.51,0,0,1,1.28.37,4.61,4.61,0,0,1,2.5,2.9,4.67,4.67,0,0,1,.17.87,5,5,0,0,1,0,.88,4.77,4.77,0,0,1-.12.76,4.53,4.53,0,0,1-.24.73,4.33,4.33,0,0,1-1.35,1.73.08.08,0,0,0,0,.11l.7,1.85.3.8a7.35,7.35,0,0,0,3-3.52,7.5,7.5,0,0,0-.09-5.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M143.6,185.22a7.36,7.36,0,0,0,2-2.82A7.36,7.36,0,0,1,143.6,185.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M138.51,174.89a5.38,5.38,0,0,1,.89,0,5.52,5.52,0,0,0-.75-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78,123.91l-.3-.8-.7-1.85a.08.08,0,0,1,0-.11,4.33,4.33,0,0,0,1.35-1.73,4.6,4.6,0,0,0,.36-1.49,4.82,4.82,0,0,0-.18-1.75A4.55,4.55,0,0,0,77.2,114a4.49,4.49,0,0,0-2.39-1.09,4.64,4.64,0,0,0-3.7,1,4.47,4.47,0,0,0-1.57,2.56,4.73,4.73,0,0,0,.23,2.87,4.3,4.3,0,0,0,1.32,1.76l.07.06a.09.09,0,0,1,0,.07l-1,2.64v0a7.39,7.39,0,0,1-3.41-7.85,7.49,7.49,0,0,1,14.59-.39A7.41,7.41,0,0,1,78,123.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.07,82.36l-.15-.4L75.56,81a0,0,0,0,1,0-.05,2.16,2.16,0,0,0,.67-.87,2.3,2.3,0,0,0,.18-.75,2.41,2.41,0,0,0-.09-.87,2.28,2.28,0,0,0-.69-1.08,2.24,2.24,0,0,0-1.19-.55,2.32,2.32,0,0,0-1.85.5,2.23,2.23,0,0,0-.79,1.28,2.37,2.37,0,0,0,.12,1.44,2.15,2.15,0,0,0,.66.88l0,0a0,0,0,0,1,0,0l-.5,1.32h0a3.69,3.69,0,0,1-1.7-3.92,3.74,3.74,0,0,1,7.3-.19A3.71,3.71,0,0,1,76.07,82.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67,100.45l-.21-.55-.48-1.26a.05.05,0,0,1,0-.07,3,3,0,0,0,.92-1.18,3.15,3.15,0,0,0,.25-1,3.29,3.29,0,0,0-.12-1.2,3.11,3.11,0,0,0-.95-1.48,3.07,3.07,0,0,0-1.63-.75,3.17,3.17,0,0,0-2.53.69,3.05,3.05,0,0,0-1.07,1.75,3.23,3.23,0,0,0,.16,2,2.94,2.94,0,0,0,.9,1.2l0,0a.06.06,0,0,1,0,0l-.68,1.81v0a5,5,0,0,1-2.33-5.36,5.12,5.12,0,0,1,10-.26A5.07,5.07,0,0,1,67,100.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M49.51,88.18l-.2-.54-.47-1.24a.05.05,0,0,1,0-.07,2.9,2.9,0,0,0,.9-1.16,3.08,3.08,0,0,0,.24-1A3.23,3.23,0,0,0,49.88,83a3,3,0,0,0-.93-1.45,3,3,0,0,0-1.6-.73,3.11,3.11,0,0,0-2.48.67,3,3,0,0,0-1.05,1.71A3.17,3.17,0,0,0,44,85.12a2.88,2.88,0,0,0,.89,1.18l0,0a.06.06,0,0,1,0,0l-.67,1.77v0A5,5,0,0,1,42,82.92a5,5,0,0,1,9.78-.26A5,5,0,0,1,49.51,88.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M45.08,58.62l-.1-.27-.24-.62a0,0,0,0,1,0,0,1.45,1.45,0,0,0,.45-.58,1.54,1.54,0,0,0,.12-.5,1.61,1.61,0,0,0-.06-.59,1.52,1.52,0,0,0-.47-.73,1.5,1.5,0,0,0-.8-.37,1.55,1.55,0,0,0-1.24.34,1.5,1.5,0,0,0-.53.86,1.58,1.58,0,0,0,.08,1,1.44,1.44,0,0,0,.44.59l0,0a0,0,0,0,1,0,0l-.34.89h0A2.47,2.47,0,0,1,41.3,56a2.51,2.51,0,0,1,4.89-.13A2.48,2.48,0,0,1,45.08,58.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M37.83,72.22l-.14-.37L37.37,71a0,0,0,0,1,0-.05,2,2,0,0,0,.62-.79,2.11,2.11,0,0,0,.17-.68,2.21,2.21,0,0,0-.08-.8,2.08,2.08,0,0,0-.64-1,2.06,2.06,0,0,0-1.09-.5,2.12,2.12,0,0,0-1.69.46,2,2,0,0,0-.72,1.17A2.17,2.17,0,0,0,34,70.13a2,2,0,0,0,.61.81l0,0a0,0,0,0,1,0,0l-.46,1.21h0a3.38,3.38,0,0,1-1.56-3.59,3.43,3.43,0,0,1,6.68-.18A3.39,3.39,0,0,1,37.83,72.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M62.27,70.83l-.17-.45-.39-1a0,0,0,0,1,0-.06,2.42,2.42,0,0,0,.75-1,2.58,2.58,0,0,0,.2-.84,2.7,2.7,0,0,0-.1-1,2.55,2.55,0,0,0-.78-1.21,2.51,2.51,0,0,0-1.34-.61,2.6,2.6,0,0,0-2.07.56,2.5,2.5,0,0,0-.88,1.43,2.65,2.65,0,0,0,.13,1.61,2.41,2.41,0,0,0,.74,1l0,0a0,0,0,0,1,0,0l-.56,1.48h0A4.13,4.13,0,0,1,56,66.43a4.19,4.19,0,0,1,8.17-.22A4.15,4.15,0,0,1,62.27,70.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M48,39.84l-.09-.22-.2-.52a0,0,0,0,1,0,0,1.21,1.21,0,0,0,.38-.48,1.29,1.29,0,0,0,.1-.42,1.35,1.35,0,0,0-.05-.49,1.27,1.27,0,0,0-.39-.61,1.26,1.26,0,0,0-.67-.31A1.3,1.3,0,0,0,46,37a1.25,1.25,0,0,0-.44.72,1.32,1.32,0,0,0,.06.8,1.2,1.2,0,0,0,.37.49l0,0a0,0,0,0,1,0,0l-.28.74h0a2.07,2.07,0,0,1-1-2.2,2.1,2.1,0,0,1,4.08-.11A2.07,2.07,0,0,1,48,39.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M58.21,52.86l-.12-.31-.27-.71a0,0,0,0,1,0,0,1.66,1.66,0,0,0,.51-.66,1.76,1.76,0,0,0,.14-.57,1.84,1.84,0,0,0-.07-.67,1.74,1.74,0,0,0-.53-.83,1.72,1.72,0,0,0-.91-.42,1.77,1.77,0,0,0-1.42.39,1.71,1.71,0,0,0-.6,1,1.81,1.81,0,0,0,.09,1.1,1.65,1.65,0,0,0,.51.67l0,0a0,0,0,0,1,0,0l-.38,1h0a2.83,2.83,0,0,1-1.3-3,2.86,2.86,0,0,1,5.58-.15A2.84,2.84,0,0,1,58.21,52.86Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 153.93,
    cy: 102.66,
    rx: 4.86,
    ry: 5.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 154.98,
    cy: 103.11,
    rx: 2.27,
    ry: 2.75
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 156.14,
    cy: 102.84,
    rx: 0.74,
    ry: 0.89
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 151.53,
    cy: 105.13,
    rx: 1.1,
    ry: 1.33
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 157.47,
    cy: 102.15,
    rx: 0.42,
    ry: 0.51
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobot05);
export default __webpack_public_path__ + "static/media/robot-05.f9c351a5ebb3a15eb672d5a5caccc7ca.svg";
export { ForwardRef as ReactComponent };